import React, { useState } from "react";

import NavbarData from "../../../AppData/NavbarData";
import NavItem from "./NavItem";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDrawer = () => {
    setIsOpen(!isOpen);
  };

  const closeDrawer = () => {
    setIsOpen(false);
  };

  return (
    <>
      <nav className='w-full bg-primary-dark px-4 sm:px-6 md:px-8 lg:px-10 md:fixed md:top-0 z-50'>
        <div className='max-w-7xl mx-auto flex items-center justify-between py-2 md:py-4'>
          {/* Logo */}
          <a href='/' className='flex items-center'>
            <img
              src='/logo-dark.svg'
              alt='Ancy Friz Logo'
              width={110}
              height={36}
              className='md:w-[135px] md:h-[45px] w-[110px] h-[36px] transition-transform duration-300 hover:scale-105'
            />
          </a>

          {/* Hamburger Button for mobile screens */}
          <button
            className='text-3xl md:text-4xl text-accent-gold cursor-pointer md:hidden transition-colors hover:text-emerald-glow p-2 rounded-lg hover:bg-primary-dark/80'
            onClick={toggleDrawer}
            aria-label={isOpen ? "Close menu" : "Open menu"}
            aria-expanded={isOpen}
            aria-controls="mobile-drawer">
            {isOpen ? "✕" : "☰"}
          </button>

          {/* Desktop Links */}
          <div className='hidden md:flex md:ml-auto items-center md:space-x-6 lg:space-x-8'>
            {NavbarData.map((item) => (
              <NavItem
                key={item.id}
                to={item.link}
                label={item.title}
                className='text-text-light hover:text-accent-gold font-medium transition-colors duration-300 relative group'
              />
            ))}
          </div>
        </div>

        {/* Mobile Drawer */}
        <div
          id="mobile-drawer"
          className={`fixed top-0 right-0 bg-primary-light transform transition-all duration-300 ease-in-out ${
            isOpen
              ? "translate-x-0 min-h-screen z-50"
              : "translate-x-full"
          } w-3/4 sm:w-1/2 md:hidden`}>
          {/* Close Button */}
          <div className='flex justify-end p-6'>
            <button
              className='text-3xl text-text-primary hover:text-accent-gold cursor-pointer transition-colors p-2 rounded-lg hover:bg-gray-100'
              onClick={closeDrawer}
              aria-label="Close menu">
              ✕
            </button>
          </div>

          {/* Drawer Links */}
          <div className='flex flex-col items-start space-y-5 px-8 pb-8 text-text-primary'>
            {NavbarData.map((item) => (
              <NavItem
                key={item.id}
                to={item.link}
                onClick={closeDrawer}
                textColor='text-text-primary hover:text-accent-gold'
                icon={item.icon}
                label={item.title}
              />
            ))}
          </div>
        </div>
      </nav>

      {/* Spacer for fixed navbar - only on desktop (matches actual navbar height) */}
      <div className='hidden md:block h-20 bg-primary-dark'></div>
    </>
  );
};

export default Navbar;
